import React from 'react';
import PropTypes from 'prop-types';
import Input from '../form-elements/input';

const Search = (props) => {
    const {
        placeholder = 'Search',
        onSearchText
    } = props;

    return (
        <div className="w-full flex">

            <Input
                type = "search" 
                placeholder = { placeholder }
                onChange = {onSearchText}
            />
        </div>
    )
}

Search.propTypes = {
    onSearchText : PropTypes.func,
    placeholder : PropTypes.string
};

export default Search;